import './TargetNameAndDescription.css';
import { inactiveTargetStates } from '@/tmp/Target';
import { MinimalTarget } from '@/generated/model';

// eslint-disable-next-line react-refresh/only-export-components
export function targetNameAndDescriptionStyle(
  selected: boolean | undefined,
  hasStatus: boolean | undefined,
  inactive: boolean = false
): string {
  switch (selected) {
    case true:
      switch (hasStatus) {
        case false:
          return 'target-name-and-description-selected-nostatus';
        case true:
        case undefined:
          return 'target-name-and-description-selected';
        default:
          console.log('this should not happen');
          return '';
      }
    case false:
      if (inactive) {
        return 'target-name-and-description-inactive';
      }
      return 'target-name-and-description-nonselected';
    case undefined:
      return 'target-name-and-description-header';
  }
}

// eslint-disable-next-line react-refresh/only-export-components
export function isTargetInactiveByState(target: MinimalTarget) {
  return inactiveTargetStates.includes(target.state);
}

export function TargetNameAndDescription({
  targetName,
  targetDescription,
  styleClassName,
}: {
  targetName: string | undefined;
  targetDescription: string | undefined;
  styleClassName: string | undefined;
}) {
  return (
    <div className={styleClassName}>
      <div data-qa-element-id="target_name">{targetName}</div>
      <div className="target-name-and-description-description" data-qa-element-id="target_description">
        {targetDescription}
      </div>
    </div>
  );
}
